var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.posInfo && _vm.posInfo.inventorySet && _vm.posInfo.inventorySet.exists)?_c('div',[_c('pre',[_vm._v("    "+_vm._s(JSON.stringify(_vm.posInfo.inventorySet.data, null, 4))+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }